import api from "lib/api/api";
import {
  FETCH_TEACHER_APPROVED_COURSES_FAILURE,
  FETCH_TEACHER_APPROVED_COURSES_REQUEST,
  FETCH_TEACHER_APPROVED_COURSES_SUCCESS,
} from "./types"; // Import the types

export const fetchTeacherApprovedCourses = (userId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_TEACHER_APPROVED_COURSES_REQUEST });

    // Make the API call to get approved courses for the teacher
    const response = await api.get(`/teachers/approved/${userId}`);

    // If successful, dispatch success with data
    dispatch({
      type: FETCH_TEACHER_APPROVED_COURSES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    // Dispatch failure action if there's an error
    dispatch({
      type: FETCH_TEACHER_APPROVED_COURSES_FAILURE,
      payload: error.response
        ? error.response.data
        : "Error fetching approved courses",
    });
  }
};
